import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import BrandMark from "../components/BrandMark";
import { COMPANY } from "../lib/company";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-black/10">
        <div className="max-w-screen-xl mx-auto px-8 py-5 flex items-center justify-between">
          <BrandMark />
          <Link to="/" className="hop-link text-sm">← на главную</Link>
        </div>
      </header>

      <main className="flex-1">
        <article className="max-w-3xl mx-auto px-8 py-16 md:py-24">
          <div className="label-mono">152-ФЗ · ПОЛИТИКА</div>
          <h1 className="mt-3 text-4xl md:text-5xl tracking-tight font-medium">
            Политика обработки<br />персональных данных
          </h1>
          <p className="mt-4 text-foreground/60 mono text-xs">Редакция от 29 апреля 2026 г.</p>

          <div className="prose mt-12 space-y-8 text-foreground/85 leading-relaxed">

            <Section num="01" title="Общие положения">
              <p>
                Настоящая Политика обработки персональных данных (далее — Политика) разработана
                в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ
                «О&nbsp;персональных данных» (далее — 152-ФЗ) и определяет порядок обработки
                персональных данных пользователей онлайн-сервиса диагностики стартапов,
                размещённого на домене {COMPANY.service.domain} (далее — Сервис).
              </p>
              <p>
                Оператором персональных данных является {COMPANY.legalName}, ИНН {COMPANY.inn},
                ОГРН {COMPANY.ogrn}, юридический адрес: {COMPANY.address} (далее — Оператор).
                Настоящая Политика применяется ко всем сведениям, которые Оператор получает
                от пользователей Сервиса.
              </p>
              <p>
                Использование Сервиса означает безоговорочное согласие пользователя
                с настоящей Политикой и условиями обработки его персональных данных.
                В случае несогласия пользователю следует прекратить использование Сервиса.
              </p>
            </Section>

            <Section num="02" title="Состав обрабатываемых данных">
              <p>Оператор обрабатывает следующие персональные данные пользователя:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>имя контактного лица стартапа;</li>
                <li>адрес электронной почты;</li>
                <li>телефон (если указан);</li>
                <li>псевдоним в Telegram (если указан);</li>
                <li>название и сайт стартапа;</li>
                <li>ответы на вопросы анкеты, включая открытые текстовые описания проекта;</li>
                <li>технические данные: IP-адрес, версия браузера, отметки времени посещений,
                    данные cookie технического характера.</li>
              </ul>
              <p>
                Оператор не собирает специальные категории персональных данных
                (национальность, политические взгляды, состояние здоровья и т. п.)
                и биометрические данные.
              </p>
            </Section>

            <Section num="03" title="Цели обработки">
              <ul className="list-disc pl-6 space-y-1">
                <li>расчёт диагностических индексов готовности стартапа и формирование
                    рекомендаций;</li>
                <li>хранение результатов оценки и предоставление пользователю доступа к ним
                    по сохранённой ссылке;</li>
                <li>статистический и методологический анализ выборки в обезличенном виде
                    для совершенствования методики оценки;</li>
                <li>связь с пользователем по поводу поданной им анкеты, если это необходимо.</li>
              </ul>
            </Section>

            <Section num="04" title="Правовые основания обработки">
              <p>
                Обработка осуществляется на основании: статьи 6, части 1, пунктов 1
                (согласие пользователя) и&nbsp;5 (исполнение договорных обязательств,
                стороной которого является пользователь) 152-ФЗ.
              </p>
              <p>
                Согласие пользователя оформляется в&nbsp;виде проставления отметок в&nbsp;соответствующих
                чекбоксах перед заполнением анкеты и подтверждается отправкой анкеты.
              </p>
            </Section>

            <Section num="05" title="Использование искусственного интеллекта">
              <p>
                Открытые текстовые ответы пользователя и&nbsp;содержимое загруженной презентации
                могут передаваться сторонним языковым моделям для анализа, извлечения
                структурированных признаков и&nbsp;их&nbsp;пересчёта в&nbsp;баллы, влияющие
                на&nbsp;итоговые индексы. Передача осуществляется через защищённое соединение,
                обработка ограничена целями оказания услуг Сервиса.
              </p>
              <p>
                Передача данных языковой модели осуществляется только при наличии
                отдельного отмеченного согласия пользователя.
              </p>
            </Section>

            <Section num="06" title="Срок хранения и удаление">
              <p>
                Срок хранения персональных данных составляет {COMPANY.retentionMonths} месяцев
                с момента подачи анкеты. По истечении срока данные удаляются или
                обезличиваются.
              </p>
              <p>
                Пользователь вправе в любое время направить запрос на досрочное удаление
                своих персональных данных по адресу <a className="hop-link" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
                Запрос рассматривается в течение 10 рабочих дней.
              </p>
            </Section>

            <Section num="07" title="Меры защиты">
              <p>
                Оператор принимает технические и организационные меры для защиты
                персональных данных: разграничение доступа, шифрование канала
                (TLS), резервное копирование, аудит действий администраторов,
                обезличивание при аналитике.
              </p>
            </Section>

            <Section num="08" title="Передача третьим лицам">
              <p>
                Оператор вправе передавать персональные данные третьим лицам
                в&nbsp;случаях, предусмотренных законодательством Российской Федерации,
                а&nbsp;также партнёрам Оператора, участвующим в&nbsp;реализации проекта
                (в&nbsp;том числе для целей организации мероприятий, обработки заявок,
                предоставления пользователям материалов и&nbsp;иной деятельности,
                связанной с&nbsp;проектом) и&nbsp;поставщикам языковых моделей в&nbsp;рамках,
                описанных в&nbsp;разделе 05, при условии соблюдения требований
                законодательства Российской Федерации о&nbsp;персональных данных.
              </p>
            </Section>

            <Section num="09" title="Cookie-файлы">
              <p>
                Сервис использует только технически необходимые cookie-файлы,
                требующиеся для корректной работы (хранение прогресса прохождения
                анкеты, идентификация сессии). Аналитические и маркетинговые cookie
                на момент действия настоящей редакции не&nbsp;используются.
              </p>
            </Section>

            <Section num="10" title="Права пользователя">
              <p>В соответствии со ст. 14, 21 152-ФЗ пользователь имеет право:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>получить сведения об обработке своих персональных данных;</li>
                <li>требовать уточнения, блокирования или удаления данных;</li>
                <li>отозвать согласие на обработку;</li>
                <li>обжаловать действия Оператора в Роскомнадзоре или в&nbsp;суде.</li>
              </ul>
              <p>
                Все запросы направляются на <a className="hop-link" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
              </p>
            </Section>

            <Section num="11" title="Изменения Политики">
              <p>
                Оператор вправе вносить изменения в настоящую Политику. Актуальная редакция
                всегда публикуется по адресу https://{COMPANY.service.domain}/privacy.
                Дата последней редакции указана в начале документа.
              </p>
            </Section>

            <Section num="12" title="Контакты Оператора">
              <p>
                {COMPANY.legalName}<br />
                Адрес: {COMPANY.address}<br />
                ИНН {COMPANY.inn}, КПП {COMPANY.kpp}, ОГРН {COMPANY.ogrn}<br />
                Телефон: {COMPANY.phone}<br />
                E-mail: <a className="hop-link" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
              </p>
            </Section>

          </div>
        </article>
      </main>

      <Footer />
    </div>
  );
}

function Section({ num, title, children }) {
  return (
    <section>
      <div className="label-mono mb-3">{num}</div>
      <h2 className="text-2xl font-medium tracking-tight">{title}</h2>
      <div className="mt-4 space-y-3">{children}</div>
    </section>
  );
}
